<template>
  <simple-modal :min-width="minWidth" v-bind="$attrs" v-on="$listeners">
    <md-card class="card-modal">
      <md-card-header>
        <slot name="header"> </slot>
      </md-card-header>
      <md-card-content>
        <slot name="body"> </slot>

        <slot> </slot>
      </md-card-content>

      <md-card-actions>
        <slot name="footer"> </slot>
      </md-card-actions>
    </md-card>
  </simple-modal>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    minWidth: {
      type: [Number, String],
      default: 500
    }
  }
}
</script>

<style lang="css" scoped>
.md-card.card-modal {
  margin-top: 0px;
}

.card-modal.md-card .md-card-content .md-form-label {
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
  text-align: unset;
}

.md-card,
.md-card-content,
.md-card-actions {
  border: none !important;
  box-shadow: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Modal.vue